import { render, staticRenderFns } from "./ProductDetailBox.vue?vue&type=template&id=301a02be"
import script from "./ProductDetailBox.vue?vue&type=script&lang=js"
export * from "./ProductDetailBox.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailBox.vue?vue&type=style&index=0&id=301a02be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports